export default class Payment{
    constructor({dueDate=null, terms=null, paidInFull=true}){
        this.dueDate = dueDate;
        this.terms = terms;
        this.paidInFull = paidInFull;
    }
};